var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B3F2A3",
    d: "M24.376 4.963L0.3 4.963 3.146 0.364 21.53 0.364z",
    transform: "translate(.121 .708)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C494",
    d: "M1.805 4.963v12.675c0 .975.741 1.764 1.655 1.764h6.871V13.24c0-.264.202-.478.45-.478h3.933c.249 0 .45.214.45.478v6.162h7.707V4.962H1.805z",
    transform: "translate(.121 .708)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3F2A3",
    d: "M.3 5.722v2.08c0 .886.674 1.604 1.505 1.604.83 0 1.505-.718 1.505-1.604v-2.08H.3zM3.31 5.722v2.08c0 .886.674 1.604 1.504 1.604.831 0 1.505-.718 1.505-1.604v-2.08H3.31zM6.32 5.722v2.08c0 .886.673 1.604 1.504 1.604.83 0 1.505-.718 1.505-1.604v-2.08h-3.01z",
    transform: "translate(.121 .708)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3F2A3",
    d: "M9.329 5.722v2.08c0 .886.674 1.604 1.504 1.604.831 0 1.505-.718 1.505-1.604v-2.08h-3.01z",
    transform: "translate(.121 .708)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3F2A3",
    d: "M12.338 5.722v2.08c0 .886.673 1.604 1.505 1.604.83 0 1.505-.718 1.505-1.604v-2.08h-3.01z",
    transform: "translate(.121 .708)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3F2A3",
    d: "M15.348 5.722v2.08c0 .886.673 1.604 1.504 1.604s1.505-.718 1.505-1.604v-2.08h-3.01zM18.357 5.722v2.08c0 .886.674 1.604 1.505 1.604.83 0 1.505-.718 1.505-1.604v-2.08h-3.01z",
    transform: "translate(.121 .708)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3F2A3",
    d: "M21.367 5.722v2.08c0 .886.674 1.604 1.505 1.604.83 0 1.504-.718 1.504-1.604v-2.08h-3.01z",
    transform: "translate(.121 .708)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C494",
    d: "M0.3 5.722L24.376 5.722 24.376 4.964 0.3 4.964z",
    transform: "translate(.121 .708)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.b46b975ec3531a4761e77e9032082a2b.svg";
export { ForwardRef as ReactComponent };